export const ENVIRONMENT = {
  DEV: "dev",
  PROD: "prod",
};

export const RADIO_SWITCHER_VALUES = {
  INPUT: "INPUT",
  OUTPUT: "OUTPUT",
  EQUIPMENT: "EQUIPMENT UTILIZATION",
};

export const DEFAULT_GRAPHS_VALUES = {
  GRAPH1: "",
  GRAPH2: "",
  GRAPH3: "",
  GRAPH4: "",
};

export const EMPTY_GRAPHS_VALUES = {
  GRAPH1: "",
  GRAPH2: "",
  GRAPH3: "",
  GRAPH4: "",
};

export const DEFAULT_GRAPHS_BEST_DAYS = {
  GRAPH1: true,
  GRAPH2: true,
  GRAPH3: true,
  GRAPH4: true,
};

export const DEFAULT_GRAPHS_BOOKMARKS = {
  GRAPH1: true,
  GRAPH2: true,
  GRAPH3: true,
  GRAPH4: true,
};

export const STOCKPILES_TABLE_COLUMNS_NUMBER = 10;

export const MAX_INPUT_VALUE = 999999;

export const STOCKPILES_TABLE_FEATURES = {
  ZN_PERCENT: "Zn_Percent",
  PB_PERCENT: "Pb_Percent",
  FE_PERCENT: "Fe_Percent",
  BA_PERCENT: "Ba_Percent",
  TOC_PERCENT: "TOC_Percent",
  ZNPB_RATIO: "ZnPb_Ratio",
  ZNFE_RATIO: "ZnFe_Ratio",
  PBFE_RATIO: "PbFe_Ratio",
  GRAIN_SIZE_T2: "Grain_Size_T2",
  SIO2_PERCENT: "SiO2_Percent",
  SPB_PERCENT: "sPb_Percent",
  ES_PERCENT: "eS_Percent",
  CU_PERCENT: "Cu_Percent",
  RPB_RATIO: "RPb_Ratio",
  GRAIN_SIZE_T1: "Grain_Size_T1",
  GRAIN_SIZE_T6: "Grain_Size_T6",
  CHEMISTRY_T3: "Chemistry_T3",
  CHEMISTRY_T4: "Chemistry_T4",
  CHEMISTRY_T5: "Chemistry_T5",
  CHEMISTRY_T7: "Chemistry_T7",
  CHEMISTRY_T8: "Chemistry_T8",
  CHEMISTRY_T9: "Chemistry_T9",
  ZN_T2: "Zn_T2",
  ZN_T1: "Zn_T1",
  ZN_T6: "Zn_T6",
  PB_T2: "Pb_T2",
  PB_T1: "Pb_T1",
  PB_T6: "Pb_T6",
  GRAIN_SIZE_T1_GRAIN_SIZE_T6: "Grain_Size_T1_Grain_Size_T6",
};

export const STOCKPILES_OUTPUT_PARAMS = {
  DISTANCE: "Distance",
  START_DATE: "Start",
  END_DATE: "End",
  MILL_TPH: "TPH (Balanced)",
  PI_TPOH: "TPOH (Unbalanced)",
  ZN_CIRCUIT_RECOVERY: "Zn Recovery",
  ZN_FINAL_CONCENTRATE_PERCENT: "Zn Final Grade",
  PB_CIRCUIT_RECOVERY: "Pb Recovery",
  PB_FINAL_CONCENTRATE_PERCENT: "Pb Final Grade",
  PASSING_325_PERCENT: "325# % Passing",
  F80: "F80",
  P80: "P80",
  BOND_WORK_INDEX: "Bond Work Index",
  SAG_KWH: "SAG kWh",
  BM_KWH: "BM kWh",
  KWH_TONNE: "kWh perTonne",
};

export const FEATURES_DEFAULT_WEIGHTS = {
  ZN_PERCENT: 100,
  PB_PERCENT: 100,
  FE_PERCENT: 100,
  BA_PERCENT: 75,
  TOC_PERCENT: 50,
  GRAIN_SIZE_T2: 50,
  SIO2_PERCENT: 5,
  SPB_PERCENT: 5,
  ES_PERCENT: 5,
  CU_PERCENT: 5,
  RPB_RATIO: 0,
  GRAIN_SIZE_T1: 0,
  GRAIN_SIZE_T6: 0,
  CHEMISTRY_T3: 0,
  CHEMISTRY_T4: 0,
  CHEMISTRY_T5: 0,
  CHEMISTRY_T7: 0,
  CHEMISTRY_T8: 0,
  CHEMISTRY_T9: 0,
  ZN_T2: 0,
  ZN_T1: 0,
  ZN_T6: 0,
  PB_T2: 0,
  PB_T1: 0,
  PB_T6: 0,
  ZNPB_RATIO: 0,
  ZNFE_RATIO: 0,
  PBFE_RATIO: 0,
  GRAIN_SIZE_T1_GRAIN_SIZE_T6: 0,
};

export const EQUIPMENT_AVAILABILITY_TABLE_PARAMS = {
  SAG_UTILIZATION: "Average of SAGs",
  SAG1_UTILIZATION: "SAG1",
  SAG2_UTILIZATION: "SAG2",
  SAG3_UTILIZATION: "SAG3",
  BM4_AVAILABLE: "BM4",
  BM1_AVAILABLE: "BM1",
  BM2_AVAILABLE: "BM2",
  BM3_AVAILABLE: "BM3",
  QUATERNARY_ISAMILL_AVAILABLE: "Quaternary Isamill",
  ZN_ROUGHER_ISAMILL_AVAILABLE: "Zn Rougher Isamill",
  PB_TOWER_MILL1_AVAILABLE: "Pb Tower Mill1",
  PB_TOWER_MILL4_AVAILABLE: "Pb Tower Mill4",
  PB_TOWER_MILL5_AVAILABLE: "Pb Tower Mill5",
};

export const STOCKPILES_SEARCH_TIME_START = "2019-11-11";

export const FORECAST_TABLE_PARAMS = {
  SP: "SP",
  numberOfDays: "numberOfDays",
  Zn_Fd: "Zn_Fd",
  Pb_Fd: "Pb_Fd",
  Zn_Rec: "Zn_Rec",
  Zn_Gr: "Zn_Gr",
  Pb_Rec: "Pb_Rec",
  Pb_Gr: "Pb_Gr",
  TPOH: "TPOH",
};

export const MATCHING_ERRORS_MESSAGES = {
  BACKEND_SERVICE:
    "We are currently reloading data. During this time, the application will be temporarily unavailable. Please check back in approximately 30 minutes.",
  MATCHING_ALGORYTHM:
    "Matching algorithm error/unavailable, please contact support - deployment specialists",
  AUTH: "Authentification error, please re-login to Galileo Portal",
};

export const GRAPHS_LINES_COLORS = [
  "#0154b0",
  "#a57882",
  "#087e8b",
  "#de3c4b",
  "#b0dbfe",
  "#58bc82",
  "#a7a5c6",
  "#8b2635",
  "#7a3b82",
  "#00FFFF",
];

export const GRAPHS_BANDS_COLORS = [
  "#ccddef",
  "#ede4e6",
  "#cee5e8",
  "#f8d8db",
  "#eff8ff",
  "#def2e6",
  "#ededf4",
  "#e8d4d7",
  "#e4d8e6",
  "#ccffff",
];

export const MATCHING_MIN_RANGE_DAYS = 180; //180 days
export const MATCHING_MIN_DATE_RANGE =
  MATCHING_MIN_RANGE_DAYS * 24 * 60 * 60 * 1000; //180 days

export const APP_INSIGHTS_EVENTS = {
  CHANGE_MATCHING_BODY: "Expand/Collapse matching table",
  CHANGE_BOOKMARKS: "Toggle bookmarks on/off",
  CHANGE_BEST_DAYS: "Toggle best days on/off",
  CHANGE_GRAPH_ZOOM: "Graph zoom",
  CHANGE_ROW_HIGHLIGHT: "Select matching table row",
  CHANGE_COL_HIGHLIGHT: "Select matching table column",
  POINT_GRAPH_ITEM: "Graph data point interaction",
  CLICK_SERIES_POINT: "Click on a graph data",
  CLICK_BOOKMARK: "Click on a bookmark",
  CREATE_BOOKMARK: "Create bookmark",
  DELETE_BOOKMARK: "Delete bookmark",
  EXPORT_FORECAST: "Export forecast",
  OPEN_APPLICATION: "Open application",
  CLICK_SEARCH_STOCKPILE: "Matching execution",
  CLICK_LOAD_STOCKPILE: "Recall matching results",
  CLICK_SAVE_FORECAST: "Save forecast",
  CHANGE_SETPOINT: "Setpoint selection",
  EXPORT_GRAPH: "Export summary report",
};

export const FEEDBACK_TYPES = {
  ISSUE: "Issue",
  ENHANCEMENT: "Enhancement",
  OTHER: "Other",
};

export const SAG_THROUGHPUT_VALUE = "MF_Dry_Tonnes";

export const INVENTORY_ADJUSTMENTS_TRESHHOLD = 25000;

export const FORECAST_PAGINATOR_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const EXPORT_TAG_MAXIMUM = 15;
